import { TypedDocumentNode, gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import { getLeagueTrackSlotsInfo_so5LeagueTrack } from './__generated__/utils.graphql';

export const getLeagueTrackSlotsInfo = withFragments(
  (so5LeagueTrack: getLeagueTrackSlotsInfo_so5LeagueTrack) => {
    const {
      maxManagerTeamsCount,
      entrySo5Leaderboard,
      mySo5LeaderboardContenders,
    } = so5LeagueTrack;

    const managerTeamBased = maxManagerTeamsCount > 0;
    const nbSlots = managerTeamBased
      ? maxManagerTeamsCount
      : entrySo5Leaderboard.teamsCap || 0;

    // Get the first slot that is not composed with or without a contender
    const nbComposedSlots = mySo5LeaderboardContenders.filter(
      contender => contender.so5Lineup
    ).length;
    const firstNotComposedSlot =
      nbComposedSlots === nbSlots ? 0 : nbComposedSlots;

    return {
      nbSlots,
      nbComposedSlots,
      firstNotComposedSlot,
      nbContenders: mySo5LeaderboardContenders.length,
    };
  },
  {
    so5LeagueTrack: gql`
      fragment getLeagueTrackSlotsInfo_so5LeagueTrack on So5LeagueTrack {
        slug
        maxManagerTeamsCount
        entrySo5Leaderboard {
          slug
          teamsCap
        }
        mySo5LeaderboardContenders(includeHiddenManagerTeam: true) {
          slug
          so5Lineup {
            id
          }
        }
      }
    ` as TypedDocumentNode<getLeagueTrackSlotsInfo_so5LeagueTrack>,
  }
);
